import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CapitalizeFirstDirective } from 'src/app/shared/directives/capitalize-first.directive';
import { Subscription } from 'rxjs';
import { StateList } from 'src/app/shared/models/constants';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
  selector: 'app-form-3310-autofill',
  standalone: true,
  templateUrl: './form-3310-autofill.component.html',
  styleUrl: './form-3310-autofill.component.scss',
  imports: [ReactiveFormsModule, NgSelectModule, CapitalizeFirstDirective],
})
export class Form3310AutofillComponent {
  private destroyRef = inject(DestroyRef);
  subscriptions = new Subscription();
  agencyForm: FormGroup;
  state_list = StateList;
  constructor(private fb: FormBuilder, public sharedService: SharedService) {
    this.agencyForm = this.fb.group({
      agency_name: ['', Validators.required],
      address: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      agency_email: ['', [Validators.required, Validators.email]],
      atf_email: [
        { value: '', disabled: true },
        [Validators.required, Validators.email],
      ],
    });
    // company_info_retrieved
        this.subscriptions.add(
          this.sharedService.company_info_retrieved$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((response) => {
              if (response.company_name) {
                this.patchFormValues();
              }
            })
        );
  }
  ngOnInit(): void {
    this.patchFormValues();
  }
  patchFormValues() {
    const autofill = this.sharedService?.company_info?.autofill_form_3310;
    if (!autofill) return;

    // Patch normal (enabled) controls
    this.agencyForm.patchValue({
      agency_name: autofill.agency_name || '',
      address: autofill.address || '',
      city: autofill.city || '',
      state: autofill.state || '',
      agency_email: autofill.agency_email || '',
    });

    // Set value for the disabled atf_email control without emitting events and keep it disabled
    const atfCtrl = this.agencyForm.get('atf_email');
    if (atfCtrl) {
      atfCtrl.setValue(
        autofill.atf_email || 'multiplehandgunsalesforms@atf.gov',
        { emitEvent: false }
      );
      atfCtrl.disable({ emitEvent: false });
    }
  }
  AddEditClick() {
    if (this.agencyForm.valid) {
      this.sharedService.updateAutofill(this.agencyForm.value);
    } else {
      alert('Please fill all required fields correctly.');
      this.agencyForm.markAllAsTouched();
    }
  }
  clearForm() {
    this.agencyForm.reset();
  }
  // Helper to get form controls
  get f() {
    return this.agencyForm.controls;
  }
}
